import { HttpContextToken } from '@angular/common/http';
//se true viene usato il token di autenticazione della compagnia di default
export const COMPANY_AUTH = new HttpContextToken<boolean>(() => false);